export default __webpack_public_path__ + "static/media/py.ccc39a63.jpg";